import { api } from "@/lib/api";

// Posts report content to the backend and triggers a PDF download in the browser.
export async function downloadReport({ title, subtitle, language = "en", sections = [], meta = null }) {
  const res = await api.post(
    "/reports/generate",
    { title, subtitle, language, sections, meta },
    { responseType: "blob" }
  );
  const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `${title.replace(/[^a-zA-Z0-9]+/g, "-").slice(0, 50) || "coverguide-report"}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}
